export default __webpack_public_path__ + "static/media/mainBgCollection.e787eeca.svg";